import { useSelector } from 'react-redux';
import betslip from '@gin-betting/betslip';
import { createStructuredSelector } from 'reselect';

import ui from 'modules/ui';
import { State } from 'types';
import { formatDecimalOdd } from 'utils';

const {
    selectors: { selectOddFormat },
} = ui;

const {
    selectors: { selectBetslipBetTotals },
} = betslip;

interface Input {
    betslipBetId: string;
}

type Output = {
    formattedTotalOdd: ReturnType<typeof formatDecimalOdd>['component'];
} | null;

const selectProps = createStructuredSelector({
    totals: selectBetslipBetTotals,
    oddFormat: selectOddFormat,
});

const useTotalOdd = ({ betslipBetId }: Input): Output => {
    const {
        totals: { totalOdd },
        oddFormat,
    } = useSelector((s: State) => selectProps(s, { betslipBetId }));

    if (!totalOdd) return null;

    const { component: formattedTotalOdd } = formatDecimalOdd(
        totalOdd || 0,
        oddFormat
    );

    return { formattedTotalOdd };
};

export default useTotalOdd;
